// extracted by mini-css-extract-plugin
export default {"section":"SimulationArgsSection_section__ZJxoe","args":"SimulationArgsSection_args__7OACW","label":"SimulationArgsSection_label__Qoy5n"};